// extracted by mini-css-extract-plugin
export default {"categoryHeader":"categoryHeader--8e96s"};